export const destructiveConfirmFooterClassName = "flex-col-reverse gap-3 sm:flex-row sm:justify-stretch";
export const destructiveConfirmFooterButtonClassName = "flex-1";
